module.exports = __webpack_public_path__ + "static/img/6.14311be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/6.png
// module id = sLy4
// module chunks = 1